export const MESSAGE_THREADS_KEY = 'messageThreads';
export const MESSAGE_UNREAD_KEY = 'messageUnreadCount';
export const messageThreadKey = (threadId) => ['messageThread', threadId];
export const messageThreadMessagesKey = (threadId) => ['messageThreadMessages', threadId];
export const messageThreadForTechKey = (technicianId) => ['messageThreadForTech', technicianId];
